import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import { formatDate, TextBox } from '../../Components/InputElements';
import Swal from 'sweetalert2';
import Select from 'react-select';
import axios from "axios";
import { decodeData } from '../../Constants/constants';


class MyLeaves extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_leave_id: '',
            leave_type_id: '',
            filter_leave_type_id: '',
            leave_category_id: '',
            employee_leave_from_date: '',
            from_date: '',
            to_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            required_document: 0,
            leave_loader: false,
            employee_leave_status: '',
            fileName: "",
            fileSize: "",
            past_days: 0,
            half_day: 0,
            selectedImage: null,
            loadingList: false,
            loadingLeave: false,
            postLoading: false,
            leave_type_row: [],
            leave_type_condition_rows: [],
            leave_log_rows: [],
            weekenddays: [],
            festivals: [],
            errors: {},
            errorMessage: '',
            check_modal_type: '',
            next: false,
            prev: false,
            LeaveRows: [],
            get_url: '',
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            salaries: [],
            salaries_statutory: [],
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
            this.GetLeaveTypeList(0);
            this.GetRemmainingLeaves();
            this.GetAssignShift();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    validateNotEmpty = (fieldName, value) => {
        if (value === undefined || value === null) {
            return `${fieldName} is required`;
        }
        if (typeof value !== 'string') {
            value = String(value);
        }
        if (value.trim() === '') {
            return `${fieldName} is required`;
        }
        return '';
    }

    CheckSelectWeekend = (FromDate, ToDate) => {
        const weekenddays = this.state.weekenddays;

        const fromDate = new Date(FromDate);
        const toDate = new Date(ToDate);

        const dayOfWeekMap = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };

        const isWeekendDay = (date) => {
            const dayOfWeek = dayOfWeekMap[date.getUTCDay()];
            return weekenddays.some(weekend => weekend.shift_day === dayOfWeek);
        };

        if (isWeekendDay(fromDate) && isWeekendDay(toDate)) {
            Swal.fire({
                title: 'Error',
                text: 'You cannot apply leave on your week off',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return true;
        }


        return false;
    };

    CheckSelectFestival = (FromDate, ToDate) => {
        const festivals = this.state.festivals;

        const fromDate = new Date(FromDate);
        const toDate = new Date(ToDate);

        const isFestivalDay = (date) => {
            const formattedDate = date.toISOString().split('T')[0];
            return festivals.some(festival => festival.calendar_festival_date === formattedDate);
        };

        if (isFestivalDay(fromDate) || isFestivalDay(toDate)) {
            Swal.fire({
                title: 'Error',
                text: 'You can not apply leave on holiday',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return true;
        }

        return false;
    };

    validateDate = (fieldName, value_to, value_from) => {
        const date = new Date(value_to);
        const today = new Date(value_from);
        if (date < today) {
            return `Please Select Future Date In ${fieldName}....!!`;
        }
        return '';
    }
    GetLeaveTypeList = (typelist) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveTypeList`, { params: { typelist: typelist }, headers })
            .then((response) => {

                var data = response.data;
                if (response.data.success === true) {
                    if (typelist === 0) {
                        this.setState((prevState) => ({
                            leave_type_row: data.data? data.data.map((row) => ({
                                value: row.leave_type_id,
                                label: row.leave_type_name
                            })) : [],
                        }));
                    } else {
                        this.setState((prevState) => ({
                            leave_type_condition_rows: data.data?  data.data.map((row) => ({
                                value: row.leave_type_id,
                                label: row.leave_name
                            })): [],
                        }));
                    }
                }
            });
    }

    GetLeaveTypeInfo = (leave_type_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveTypeInfo`, { params: { leave_type_id: leave_type_id }, headers }).then((response) => {
            var data = response.data.data;
            if (response.data.success === true) {
                this.setState({
                    required_document: data[0].required_document,
                    half_day: data[0].half_day,
                    future_days: data[0].future_days,
                    past_days: data[0].past_days,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetAssignShift = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAssignShift`, { headers }).then((response) => {
            var data = response.data.data;
            var festivals = response.data.festivals;
            if (response.data.success === true) {
                this.setState({
                    weekenddays: data,
                    festivals: festivals,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetApplyLeaves`, {
            params:
            {
                employee_leave_status: this.state.employee_leave_status,
                leave_type_id: this.state.filter_leave_type_id,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
            }, headers
        }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data || [],
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingLeave: false,
                });
            } else {
                this.setState({ loadingLeave: false });
            }
        });
    }
    GetRemmainingLeaves = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetRemainingLeaves`, { headers }).then((response) => {
            var data = response.data;

            if (response.data.success === true) {
                this.setState({
                    LeaveRows: data.data || [],
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetLeaveLogs = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveLogs`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
            var data = response.data;
            this.setState({ leave_log_rows: [] });
            if (response.data.success === true) {
                this.setState({
                    leave_log_rows: data.data || [],
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleCancelLeave = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Cancel Leave Remark..!!',
            input: 'text',
            inputPlaceholder: 'Enter your remark here...',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            preConfirm: (remark) => {
                if (!remark) {
                    Swal.showValidationMessage('Remark cannot be empty');
                }
                return remark;
            }
        }).then((remarkResult) => {
            if (remarkResult.isConfirmed) {
                const remark = remarkResult.value;

                this.setState({ status: true });
                const formData = {
                    employee_leave_id: id,
                    remark: remark,
                };
                axios
                    .post(`${apiURL}Home/CancelApplyLeave`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                                this.GetRemmainingLeaves();
                            })
                        }
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: '<strong>Error</strong>',
                            html: error.message,
                            icon: 'error'
                        });
                    });
            }
        });
    }


    CheckValidation = () => {
        const errors = {};
        const {
            employee_leave_from_date,
            employee_leave_to_date,
            employee_leave_reason,
            leave_type_id,
            employee_leave_from_day_unit,
            employee_leave_to_day_unit,
            half_day,
        } = this.state;
        errors.employee_leave_from_date = this.validateNotEmpty('From Date', employee_leave_from_date);
        errors.employee_leave_to_date = this.validateNotEmpty('To Date', employee_leave_to_date) || this.validateDate('To Date', employee_leave_to_date, employee_leave_from_date);
        errors.employee_leave_reason = this.validateNotEmpty('Reason', employee_leave_reason);
        errors.leave_type_id = this.validateNotEmpty('Leave Type', leave_type_id);
        errors.employee_leave_from_day_unit = this.validateNotEmpty('From Date Unit', employee_leave_from_day_unit);
        errors.employee_leave_to_day_unit = this.validateNotEmpty('To Date Unit', employee_leave_to_day_unit);

        const weekendError = this.CheckSelectWeekend(employee_leave_from_date, employee_leave_to_date);
        const festivalError = this.CheckSelectFestival(employee_leave_from_date, employee_leave_to_date);

        if (weekendError === true || festivalError === true) {
            errors.weekendError = "weekendError";
            errors.festivalError = "festivalError";
        }

        // Your validation logic for past and future dates
        const minDate = this.calculateMinDate();
        const maxDate = this.calculateMaxDate();

        // Check validation logic for both "From Date" and "To Date"
        if (employee_leave_from_date && new Date(employee_leave_from_date) < new Date(minDate)) {
            errors.employee_leave_from_date = `This leave type allows to apply till ${formatDate(minDate)}`;
        }
        if (employee_leave_to_date && new Date(employee_leave_to_date) > new Date(maxDate)) {
            errors.employee_leave_to_date = `This leave type allows to apply till ${formatDate(maxDate)}`;
        }

        if (employee_leave_from_date === employee_leave_to_date &&
            employee_leave_from_day_unit !== employee_leave_to_day_unit) {
            errors.employee_leave_to_day_unit = 'Please select same unit as From Day unit';
        }

        if (half_day === 0 && employee_leave_from_day_unit !== "Full Day") {
            errors.employee_leave_from_day_unit = 'This leave type does not allow half day, please select full day';
        }
        if (half_day === 0 && employee_leave_to_day_unit !== "Full Day") {
            errors.employee_leave_to_day_unit = 'This leave type does not allow half day, please select full day';
        }

        return errors;
    }

    handleSubmit = (isUpdate) => {
        const errors = this.CheckValidation();
        const fileInput = document.getElementById("employee_leave_document");
        const file = fileInput.files[0];

        if (this.state.required_document !== 0 && !file) {
            errors.required_document = `Document Is required...!`;
        }

        this.setState({ errors, leave_loader: true }, () => {
            if (Object.values(errors).every(error => error === '')) {

                const formData = new FormData();
                formData.append("leave_type_id", this.state.leave_type_id);
                formData.append("employee_leave_from_date", this.state.employee_leave_from_date);
                formData.append("employee_leave_to_date", this.state.employee_leave_to_date);
                formData.append("employee_leave_reason", this.state.employee_leave_reason);
                formData.append("employee_leave_to_day_unit", this.state.employee_leave_to_day_unit);
                formData.append("employee_leave_from_day_unit", this.state.employee_leave_from_day_unit);
                formData.append("required_document", this.state.required_document);

                if (isUpdate === true) {
                    formData.append("employee_leave_id", this.state.employee_leave_id);
                }
                if (file) {
                    formData.append("employee_leave_document", file);
                }

                var headers = this.context.apiHeaderFile;
                const { apiURL } = this.context;
                axios.post(`${apiURL}Home/CreateApplyLeave`, formData, { headers })
                    .then((response) => {
                        if (response.data.success === true) {
                            Swal.fire({
                                title: `<strong>${response.data.message}</strong>`,
                                icon: `${response.data.success === true ? 'success' : 'failed'}`,
                            });
                            this.closeRef.current.click();
                            this.setState({ leave_loader: false, });
                            this.resetForm();
                            this.GetList();
                            this.GetRemmainingLeaves();
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.message}</strong>`,
                                icon: `warning`,
                            });
                            this.setState({ leave_loader: false, });
                        }
                    })
                    .catch((error) => {
                        console.error("Error uploading file:", error);
                    });
            } else {
                this.setState({ leave_loader: false, });
                console.log("Form submission failed due to errors:", errors);
            }
        });
    };



    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }

    handleSelectStatus = (selectedOption) => {
        this.setState({ employee_leave_status: selectedOption.value, });
    };
    handleSelectType = (selectedOption) => {
        this.setState({ filter_leave_type_id: selectedOption.value, });
    };



    resetemployee_leave_document = () => {

        const employee_leave_document = document.getElementById("employee_leave_document");
        if (employee_leave_document) {
            employee_leave_document.value = null;
        }

        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    };



    handleFileChange = (e) => {
        const file = e.target.files[0];
        const { errors } = this.state;
        if (file) {
            const { name, size, type } = file;
            const fileSizeInMB = size / (1024 * 1024);
            errors.required_document = '';
            if (fileSizeInMB > 10) {
                this.setState({
                    errorMessage: "File size exceeds the maximum limit of 10 MB",
                });
                console.error("File size exceeds the maximum limit of 10 MB");
                return;
            }
            let newState = {
                fileName: name,
                fileSize: `${fileSizeInMB.toFixed(2)} MB`,
                letterhead: [file],
                errorMessage: '',
            };

            if (type.startsWith("image/")) {
                newState = {
                    ...newState,
                    selectedImage: URL.createObjectURL(file),
                    fileTypeIcon: "ri-image-fill",
                };
            } else {
                newState = {
                    ...newState,
                    isValidPdfFile: true,
                    fileTypeIcon: "ri-file-pdf-fill",
                };
            }
            this.setState(newState);
            this.setState({ errors });
        }
    };


    GetLeaveInfo = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Home/GetLeaveInfo`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
            const { data, success } = response.data;
            this.setState({ get_url: '' });
            if (success === true) {

                this.setState(
                    {
                        leave_type_id: data[0].leave_type_id,
                        employee_leave_from_date: data[0].employee_leave_from_date,
                        employee_leave_to_date: data[0].employee_leave_to_date,
                        employee_leave_document: data[0].employee_leave_document,
                        employee_leave_reason: data[0].employee_leave_reason,
                        employee_leave_from_day_unit: data[0].employee_leave_from_day_unit,
                        employee_leave_to_day_unit: data[0].employee_leave_to_day_unit,
                        get_url: data[0].employee_leave_document_url,
                    }
                )
            }
        });
    }

    calculateMinDate() {
        const today = new Date();
        const pastDays = this.state.past_days;
        const pastDate = new Date(today);
        pastDate.setDate(today.getDate() - pastDays);

        const year = pastDate.getFullYear();
        const month = String(pastDate.getMonth() + 1).padStart(2, '0');
        const day = String(pastDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    calculateMaxDate() {
        const today = new Date();
        const futureDays = this.state.future_days;
        const futureDate = new Date(today);
        futureDate.setDate(today.getDate() + futureDays);

        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const day = String(futureDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }




    handleCheckModalType = (CheckModalType, employee_leave_id) => {
        if (CheckModalType === 0) {
            this.resetForm();
            this.GetLeaveTypeList(1);
            this.setState({
                check_modal_type: CheckModalType,
                get_url: '',
                employee_leave_id: 0,
                errors: {},
            });
        }
        else if (CheckModalType === 1) {

            this.setState({
                check_modal_type: CheckModalType,
                employee_leave_id: employee_leave_id,
                errors: {},
            });
            this.GetLeaveInfo(employee_leave_id);
        }
        else if (CheckModalType === 2) {

            this.setState({
                check_modal_type: CheckModalType,
                errors: {},
            });
            this.GetLeaveInfo(employee_leave_id);
            this.GetLeaveLogs(employee_leave_id);
        }
    }

    handleDeleteImage = () => {
        this.setState({
            selectedImage: null,
            fileName: "",
            fileSize: "",

        });
        this.resetemployee_leave_document();
    };
    handleFilter = () => {
        this.GetList();
    }


    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleClearAll = () => {
        this.setState(
            {
                filter_leave_type_id: '',
                employee_leave_status: '',
                from_date: '',
                to_date: '',
                rows: [],
            },
            () => {
                this.GetList();
            }
        );
    };

    handleSelect = (selectedOption) => {
        const { value } = selectedOption;
        const errorMessage = this.validateNotEmpty('Leave Type', value);
        this.GetLeaveTypeInfo(value);
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            selectedImage: null,
            fileName: "",
            fileSize: "",
        });
        this.setState({
            leave_type_id: value,
            errors: {
                leave_type_id: errorMessage
            }
        });
    };
    handleSelectChange = (name, selectedOption) => {

        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    render() {
        const { errorMessage, leave_log_rows, loadingList, LeaveRows, errors } = this.state;

        const statusOptions = [
            { value: '0', label: 'Pending' },
            { value: '2', label: 'Approved' },
            { value: '1', label: 'Rejected' },
            { value: '3', label: 'Canceled' },
        ];

        const UnitOptions = [
            { value: "First Half", label: "First Half" },
            { value: "Second Half", label: "Second Half" },
            { value: "Full Day", label: "Full Day" }
        ];
        return (
            this.state.loadingList === false ?
                (
                    <div class="main-content" >
                        <div class="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`My Leaves`} primary={`My details`} />
                                <div className='card'>
                                    <div className='card-body'>
                                        {/* <div class="card-header bg-light bg-gradient">
                                <h6 className="card-title mb-0 text-center">My Leaves</h6>
                            </div> */}
                                        <div className='row mt-3'>
                                            <div className='col-md-8'>
                                                <div className='row'>
                                                    <div className='col-md-3'>
                                                        <TextBox type="date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <TextBox type="date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div>
                                                            <label>Check Status</label>
                                                        </div>
                                                        <Select
                                                            options={statusOptions}
                                                            value={this.state.employee_leave_status ? statusOptions.find(option => option.value === this.state.employee_leave_status) : null}
                                                            onChange={this.handleSelectStatus}
                                                            placeholder={`Select Status`}
                                                        />

                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div>
                                                            <label>Check Leave Type</label>
                                                        </div>
                                                        <Select onChange={this.handleSelectType}
                                                            placeholder={`Leave Type`}
                                                            options={this.state.leave_type_row}
                                                            value={this.state.filter_leave_type_id ? this.state.leave_type_row.find((option) => option.value === this.state.filter_leave_type_id) : null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-4 d-flex justify-content-around'>
                                                <div>
                                                    <div>
                                                        <label>Apply Filter</label>
                                                    </div>
                                                    <button type="button" onClick={this.handleFilter} className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                    </button>
                                                </div>
                                                <div>
                                                    <div>
                                                        <label>Show All </label>
                                                    </div>
                                                    <button type="button"
                                                        className={`btn btn-secondary btn-label right ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                                        onClick={this.handleClearAll}
                                                    >
                                                        <i className=" ri-database-2-line label-icon align-middle fs-16 me-2"></i> Show<span style={{  color:(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? "#FFAC96":"#FF7F5D"}}>_</span>All

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-lg-12 mt-3">
                                                <div style={{ float: "right" }}>
                                                { this.state.decodedData?.includes(2) && ( 
                                                    <button type="button" onClick={() => this.handleCheckModalType(0, 0)} className="btn btn-success btn-label waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#myModal"><i className="bx bx-add-to-queue label-icon align-middle fs-16 me-2" />Apply Leave</button>)}
                                                    <div id="myModal" ref={this.modalRef} className="modal fade" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true" style={{ display: 'none' }}>
                                                        <div className={`modal-dialog ${this.state.check_modal_type === 2 ? ('modal-xl') : "modal-lg"} `}>
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="myModalLabel">
                                                                        {this.state.check_modal_type === 0 ? "Apply Leave" :
                                                                            this.state.check_modal_type === 1 ? "Update Leave" : "View Leave Details"}
                                                                    </h5>
                                                                    <button type="button" ref={this.closeRef} className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.resetForm}> </button>
                                                                </div>
                                                                <div className="modal-body">
                                                                    <form className="row">
                                                                        <div className="col-md-12 mt-3">
                                                                            <label htmlFor="leave_type_id" className="form-label">Select Leave Type:</label>
                                                                            {!this.state.leave_type_id && <div>
                                                                                <label htmlFor="leave_type_id" className="form-label"><small className='text-muted'> Please Select Leave Type First For Other Fields</small></label>
                                                                            </div>}
                                                                            <Select
                                                                                onChange={this.handleSelect}
                                                                                isDisabled={this.state.check_modal_type === 2}
                                                                                placeholder={`Select Leave Type`}
                                                                                options={this.state.leave_type_condition_rows}
                                                                                value={this.state.leave_type_condition_rows.find(option => option.value === this.state.leave_type_id) || null}
                                                                                disabled={this.state.check_modal_type === 2}
                                                                            />
                                                                            {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                                                        </div>

                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_from_date"><span>From Date</span></label>
                                                                            <input
                                                                                type="date"
                                                                                id="employee_leave_from_date"
                                                                                name="employee_leave_from_date"
                                                                                disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                                value={this.state.employee_leave_from_date}
                                                                                className='form-control'
                                                                                onChange={this.handleInputChange}
                                                                            />

                                                                            {errors.employee_leave_from_date && <div className="text-danger">{errors.employee_leave_from_date}</div>}

                                                                        </div>
                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_from_day_unit" className="form-label">Form Date Unit:</label>
                                                                            <Select
                                                                                id="employee_leave_from_day_unit"
                                                                                name="employee_leave_from_day_unit"
                                                                                value={this.state.employee_leave_from_day_unit ? UnitOptions.find(option => option.value === this.state.employee_leave_from_day_unit) : null}
                                                                                onChange={(selectedOption) => this.handleSelectChange("employee_leave_from_day_unit", selectedOption)}
                                                                                options={UnitOptions}
                                                                                placeholder="Select from date unit"
                                                                                required
                                                                                isDisabled={this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                            />
                                                                            {errors.employee_leave_from_day_unit && <div className="text-danger">{errors.employee_leave_from_day_unit}</div>}
                                                                        </div>


                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_to_date"><span>To Date</span></label>
                                                                            <input
                                                                                type="date"
                                                                                id="employee_leave_to_date" name="employee_leave_to_date"
                                                                                value={this.state.employee_leave_to_date} className='form-control'
                                                                                disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                                onChange={this.handleInputChange} />
                                                                            {errors.employee_leave_to_date && <div className="text-danger">{errors.employee_leave_to_date}</div>}
                                                                        </div>
                                                                        <div className="col-md-6 mt-3">
                                                                            <label htmlFor="employee_leave_to_day_unit" className="form-label">To Date Unit:</label>
                                                                            <Select
                                                                                id="employee_leave_to_day_unit"
                                                                                name="employee_leave_to_day_unit"
                                                                                value={this.state.employee_leave_to_day_unit ? UnitOptions.find(option => option.value === this.state.employee_leave_to_day_unit) : null}
                                                                                onChange={(selectedOption) => this.handleSelectChange("employee_leave_to_day_unit", selectedOption)}
                                                                                options={UnitOptions}
                                                                                placeholder="Select to date unit"
                                                                                required
                                                                                isDisabled={this.state.check_modal_type === 2 || !this.state.leave_type_id}
                                                                            />
                                                                            {errors.employee_leave_to_day_unit && <div className="text-danger">{errors.employee_leave_to_day_unit}</div>}
                                                                        </div>
                                                                        <div className="col-md-12 mt-3">
                                                                            <label>Reason</label>
                                                                            <textarea type='text' rows={3} className='form-control' id='employee_leave_reason' name='employee_leave_reason' value={this.state.employee_leave_reason} disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id} label='Reason' placeholder='Enter Reason' onChange={this.handleInputChange} />
                                                                            {errors.employee_leave_reason && <div className="text-danger">{errors.employee_leave_reason}</div>}
                                                                        </div>
                                                                        <div className="col-md-12 mt-3">
                                                                            <a href={`${this.state.get_url}`}
                                                                                className={`${!this.state.get_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                                                                style={{ marginTop: "10px", float: 'right' }}
                                                                                target="_blank" rel="noopener noreferrer">
                                                                                View Uploaded Document
                                                                            </a>
                                                                        </div>
                                                                        {this.state.check_modal_type !== 2 ? (
                                                                            <div className="col-md-12 mt-3">
                                                                                <label htmlFor="employee_leave_document" className="form-label">Attachment<span className='text-muted '>{this.state.required_document === 0 ? ("(...Optional)") : "(...Requested)"}</span></label>
                                                                                <div>
                                                                                    <input
                                                                                        type="file"
                                                                                        id="employee_leave_document"
                                                                                        key={this.state.theInputKey || ""}
                                                                                        onChange={this.handleFileChange}
                                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                                        disabled={this.state.check_modal_type === 2}
                                                                                    />

                                                                                    <div className="d-flex justify-content-between mt-3">
                                                                                        <div>
                                                                                            <label
                                                                                                type="submit"
                                                                                                className="btn btn-primary btn-label waves-effect waves-light"
                                                                                                style={{ marginTop: "10px" }}
                                                                                                htmlFor="employee_leave_document"
                                                                                                disabled={this.state.check_modal_type === 2}
                                                                                            >
                                                                                                <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                                                                Choose File
                                                                                            </label>
                                                                                            {errors.required_document && <div className="text-danger">{errors.required_document}</div>}
                                                                                        </div>
                                                                                        <div>
                                                                                            {this.state.leave_loader === false ? (
                                                                                                this.state.check_modal_type === 0 ? (
                                                                                                    <button type="button" className="btn btn-success btn-label waves-effect waves-light" disabled={!this.state.leave_type_id} style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(false)}>
                                                                                                        <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                                        Apply
                                                                                                    </button>

                                                                                                ) : this.state.check_modal_type === 1 ? (
                                                                                                    <button type="button" className="btn btn-success btn-label waves-effect waves-light" style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(true)}>
                                                                                                        <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                                        Update
                                                                                                    </button>
                                                                                                ) : <></>
                                                                                            ) :
                                                                                                <>
                                                                                                    <button type="button" className="btn btn-success disabled" style={{ height: "50px" }}><i className="spinner-grow fs-15" /></button>

                                                                                                </>
                                                                                            }
                                                                                        </div>

                                                                                    </div>

                                                                                    <input
                                                                                        type="file"
                                                                                        id="employee_leave_document"
                                                                                        key={this.state.theInputKey || ""}
                                                                                        onChange={this.handleFileChange}
                                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                                    />
                                                                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                                                                    <ul
                                                                                        className="list-unstyled mb-0"
                                                                                        id="dropzone-preview"
                                                                                        style={{ display: this.state.fileName === "" ? "none" : "block", }}>
                                                                                        <li className="mt-2 dz-processing dz-error dz-complete"
                                                                                            id="dropzone-preview-list">
                                                                                            <div className="border rounded">
                                                                                                <div className="d-flex p-2">
                                                                                                    <div className="flex-shrink-0 me-3">
                                                                                                        <div className="avatar-sm bg-light rounded">
                                                                                                            <i className={this.state.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex-grow-1">
                                                                                                        <div className="pt-1">
                                                                                                            <h5
                                                                                                                className="fs-13 mb-1"
                                                                                                                data-dz-name=""
                                                                                                            >
                                                                                                                {this.state.fileName}
                                                                                                            </h5>
                                                                                                            <p
                                                                                                                className="fs-13 text-muted mb-0"
                                                                                                                data-dz-size=""
                                                                                                            >
                                                                                                                <strong>{this.state.fileSize}</strong>
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                                                                        <button
                                                                                                            type='button'
                                                                                                            data-dz-remove=""
                                                                                                            onClick={this.handleDeleteImage}
                                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                                        >
                                                                                                            <i className="ri-delete-bin-line"></i>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>) :
                                                                            <div>
                                                                                <div className="my-3">
                                                                                    <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>

                                                                                </div>
                                                                                <div className='table-responsive'>
                                                                                    <table className="table table-nowrap text-center mb-0">

                                                                                        <thead className="table-light">
                                                                                            <tr>
                                                                                                <th>Action Date</th>
                                                                                                <th>Action By</th>
                                                                                                <th>Leave Type</th>
                                                                                                <th>From Date</th>
                                                                                                <th>To Date</th>
                                                                                                <th>Total Leave Days</th>
                                                                                                <th>Reason</th>
                                                                                                <th>Remark</th>
                                                                                                <th>Status</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {leave_log_rows?.map((row) => {
                                                                                                var leave_obj = JSON.parse(row.leave_apply_object);
                                                                                                return (
                                                                                                    <tr key={row.employee_leave_log_id}>
                                                                                                        <td>{formatDate(row.created_date)}</td>
                                                                                                        <td>{row.created_by_name}</td>
                                                                                                        <td>{leave_obj.leave_type_name}</td>
                                                                                                        <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                                                                                        <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                                                                                        <td>{leave_obj.employee_leave_days}</td>
                                                                                                        <td><div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: "200px" }}>{leave_obj.employee_leave_reason}</div></td>
                                                                                                        <td><div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: "200px" }}>{row.remark}</div></td>
                                                                                                        <td ><span className={`badge bg-${row.employee_leave_log_status_class}`}>{row.employee_leave_status_label}</span></td>
                                                                                                    </tr>
                                                                                                )
                                                                                            })}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </form>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6" >
                                                <div className="card-header">
                                                    <h6 className="card-title mb-0 text-center">AVAILABLE LEAVES</h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        {loadingList ? (
                                                            <center>Loading...</center>
                                                        ) : (
                                                            LeaveRows?.length===0? (
                                                                <>
                                                                        <div class="card shadow-none">
                                                                            <div class="card-body text-center">
                                                                                <div>No Data...!!</div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                            ):(
                                                            LeaveRows?.map((LeaveRow) => (
                                                                <div className="col-md-4" key={LeaveRow.leave_type_id}>
                                                                    <div className="card">
                                                                        <div className="card-body">
                                                                            <h5 className="card-title">{LeaveRow.leave_name}</h5>
                                                                            {/* <p className="card-text">{LeaveRow.remaining_leaves} / {LeaveRow.total_leaves}</p> */}
                                                                            <h2><span class="fs-13 text-muted">{LeaveRow?.total_leaves}</span></h2>
                                                                            {/* <div className="progress">
                                                                                <div className="progress-bar" role="progressbar" style={{ width: `${(LeaveRow.remaining_leaves / LeaveRow.total_leaves) * 100}%` }} aria-valuenow={LeaveRow.remaining_leaves} aria-valuemin="0" aria-valuemax={LeaveRow.total_leaves}></div>
                                                                            </div> */}


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                )
                                                            ))
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="card-header">
                                                    <h6 className="card-title mb-0 text-center" >LEAVE HISTORY</h6>
                                                </div>
                                                <div className="card-body">
                                                    <div data-simplebar style={{ maxHeight: "350px" }}>
                                                        <ul className="list-group p-3">
                                                            {
                                                                this.state.rows.length !== 0 ? (
                                                                    this.state.rows.map(row => (
                                                                        <div className="card mb-3" key={row.employee_leave_id} style={{ borderLeft: `5px solid ${row.employee_leave_status === 0 ? 'rgb(239 174 78)' : row.employee_leave_status === 1 ? 'rgb(247 102 110)' : row.employee_leave_status === 2 ? 'rgb(60 209 136)' : 'rgb(255 127 93)'}` }}>
                                                                            <div className="card-body">
                                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                    <div>
                                                                                        <h6 className="card-title mb-2">{row.heads_labels[0].concatenated_data}</h6>
                                                                                        <small className="card-text text-muted mb-2">{formatDate(row.employee_leave_from_date)} To {formatDate(row.employee_leave_to_date)}</small> <br />
                                                                                        <small className="card-text text-muted mb-0">{row.employee_leave_from_day_unit} - {row.employee_leave_to_day_unit}</small>
                                                                                    </div>
                                                                                    {/* <div className={`badge bg-${row.employee_leave_status_class} text-white`}>
                                                            {row.employee_leave_status_label}
                                                        </div> */}
                                                                                    <div className="flex-shrink-0 ">
                                                                                        <span className={`badge badge-label bg-${row.employee_leave_status_class} text-white`}><i className="mdi mdi-circle-medium" /> {row.employee_leave_status_label}</span>

                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-flex justify-content-end align-items-center">
                                                                                { this.state.decodedData?.includes(1) && ( 
                                                                                    <button className="btn btn-outline-info btn-sm me-2" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => this.handleCheckModalType(2, row.employee_leave_id)}>
                                                                                        <i className='ri-eye-line' style={{ marginTop: "5px", marginRight: "5px" }} /> View
                                                                                    </button>)}
                                                                                    {/* {row.employee_leave_status === 0 && (
                                                                    <button className="btn btn-outline-primary btn-sm me-2" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => this.handleCheckModalType(1, row.employee_leave_id)}>
                                                                        <i className='ri-edit-box-line' style={{ marginTop: "5px", marginRight: "5px" }} /> Update
                                                                    </button>
                                                                )} */}
                                                                                    {(row.employee_leave_status === 0 || (row.employee_leave_status === 2) && new Date(row.employee_leave_from_date) >= new Date()) ? (
                                                                                        <button className="btn btn-outline-danger btn-sm" onClick={() => this.handleCancelLeave(row.employee_leave_id)}>
                                                                                            <i className='ri-close-fill' style={{ marginTop: "5px" }} /> Cancel
                                                                                        </button>
                                                                                    ) : <></>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))) :
                                                                    <>
                                                                        <div class="card shadow-none">
                                                                            <div class="card-body text-center">
                                                                                <div>No Data...!!</div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default MyLeaves;